// todo add mapping for statuses and get all colors from Nik
import type { FC } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

import type { ITheme } from '@homeviews/styles'

import Typography from '../Typography'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {},
    step: {
      display: 'flex',
      '&:last-child span': {
        display: 'none',
      },
      '& .c-verticalStepper__label': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
        height: 34,
        width: 34,
        border: '1px solid rgba(130,139,151,0.5)',
        backgroundColor: 'rgba(0,192,150,0)',
        borderRadius: '50%',
        color: theme.colors.brandDarkGrey,
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '22px',
      },
      '& .c-verticalStepper__labelWrapper': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flexShrink: 0,
        marginRight: 15,
        '& span': {
          width: 1,
          height: '100%',
          backgroundColor: 'rgba(130,139,151,0.5)',
          flex: 1,
        },
      },
      '& .c-verticalStepper__title': {
        fontSize: 18,
        letterSpacing: '-0.26px',
        lineHeight: '23px',
        color: theme.colors.grey800,
        marginTop: 5,
        fontWeight: 500,
      },
      '& .c-verticalStepper__subtitle': {
        marginBottom: 15,
        color: '#4E516B',
      },
    },
    stepActive: {
      '& .c-verticalStepper__label': {
        backgroundColor: '#000433',
        border: '1px solid #000433',
      },
    },
  }),
)

interface IStep {
  id: number
  key: string
  title: string
  subtitle: string
  titleInactive: string
  subtitleInactive: string
  active: boolean
  group: string
}

interface IProps {
  className?: string
  steps: IStep[]
  group: string
}

const VerticalStepper: FC<IProps> = ({ className, steps, group }) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)}>
      {steps
        .filter((step: IStep) => step.group === group)
        .map((step: IStep) => (
          <div
            className={clsx(classes.step, step.active && classes.stepActive)}
            key={step.id}
          >
            <div className="c-verticalStepper__labelWrapper">
              <div className="c-verticalStepper__label">
                {step.active ? (
                  <img src="assets/icons/medium/tick2.svg" alt="tick" />
                ) : (
                  step.id
                )}
              </div>
              <span />
            </div>
            <div className="c-verticalStepper__content">
              <Typography className="c-verticalStepper__title">
                {step.active ? step.title : step.titleInactive}
              </Typography>
              <Typography className="c-verticalStepper__subtitle">
                {step.active ? step.subtitle : step.subtitleInactive}
              </Typography>
            </div>
          </div>
        ))}
    </div>
  )
}

export default VerticalStepper
